// @ts-nocheck

import debugLib from 'debug';
import type { AppOrOrgLevelAttributionSettings } from '../../../../shared/types/attributionSettingsTypes';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import NotificationActions from '../../main/actions/NotificationActions';
import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { App } from '../types/appTypes';

const errorProvider = new ErrorProvider();
const debug = debugLib('AppActions');
// TODO do these on something like start-init.js
export const MOUNT_APP = 'MOUNT_APP';
export function mountCurrentAppId(app_id: string) {
  return function (dispatch: (arg0: {}) => void) {
    return dispatch({
      type: MOUNT_APP,
      app_id,
    });
  };
}
export const APP_INITIALIZED = 'APP_INITIALIZED';
export function appInitializationComplete() {
  return function (dispatch: (arg0: {}) => void) {
    return dispatch({
      type: APP_INITIALIZED,
    });
  };
}
const FetchCurrentApp = new ReduxAsyncAction('FETCH_CURRENT_APP');
FetchCurrentApp.registerRequest(() => {
  return dash_api
    .get('/v1/app')
    .then(({ data: app }) => {
      return {
        app,
      };
    })
    .catch(() => {
      NotificationActions.entityError('Error fetching current app');
    });
});
export const fetchCurrentApp = FetchCurrentApp.request;
export const FETCH_CURRENT_APP = FetchCurrentApp.constants;
const FetchApps = new ReduxAsyncAction('FETCH_APPS');
FetchApps.registerRequest(() => {
  return dash_api
    .get('/v1/app/fetch-all')
    .then(({ data: apps }) => apps)
    .catch((err) => {
      debug(err);
      NotificationActions.entityError('Error fetching apps');
    });
});
export const fetchApps = FetchApps.request;
export const FETCH_APPS = FetchApps.constants;
const FetchTuneSiteData = new ReduxAsyncAction('FETCH_TUNE_SITE_DATA');
FetchTuneSiteData.registerRequest(() => {
  return dash_api
    .get('/v1/app/fetch-tune-site-data')
    .then(({ data: siteData }) => siteData)
    .catch((err) => {
      debug(err);
    });
});
export const fetchTuneSiteData = FetchTuneSiteData.request;
export const FETCH_TUNE_SITE_DATA = FetchTuneSiteData.constants;
const FetchAppsPermissions = new ReduxAsyncAction('FETCH_APPS_PERMISSIONS');
FetchAppsPermissions.registerRequest(() => {
  return dash_api
    .get('/v1/app/permissions/fetch-all')
    .then(({ data: appsPermissions }) => appsPermissions)
    .catch((err) => {
      debug(err);
      NotificationActions.entityError('Error fetching app permissions');
    });
});
export const fetchAppsPermissions = FetchAppsPermissions.request;
export const FETCH_APPS_PERMISSIONS = FetchAppsPermissions.constants;
const SaveAppAttributionWindows = new ReduxAsyncAction('SAVE_APP_ATTRIBUTION_WINDOWS');
SaveAppAttributionWindows.registerRequest(function (windows: AppOrOrgLevelAttributionSettings | null | undefined = null) {
  NotificationActions.entitySaving();
  return dash_api
    .post('/v1/app/attribution-windows', {
      windows,
    })
    .then(({ data: app }) => {
      NotificationActions.entitySaved(app);
      return app;
    })
    .catch((err) => {
      debug(err);
      NotificationActions.entityError(
        errorProvider.parse(err).getFieldEmpty() ||
          'Failed to save new attribution window settings, please check that fields are valid'
      );
    });
});
export const saveAppAttributionWindows = SaveAppAttributionWindows.request;
export const SAVE_APP_ATTRIBUTION_WINDOWS = SaveAppAttributionWindows.constants;
const UpdateApp = new ReduxAsyncAction('UPDATE_APP');
UpdateApp.registerRequest(function (body: App, localOnly: boolean) {
  // if the persisted App model has already been set and saved (i.e. subdomain update)
  // we can just update the local App model
  if (localOnly) {
    this.dispatch({
      type: this.constants.response,
      data: body,
    });
    return {};
  }

  return dash_api.post('/v1/callback/settings save', body).then((res) => {
    return res.data.value;
  });
});
export const UPDATE_APP = UpdateApp.constants;
export const updateApp = UpdateApp.request;
export const NO_APP = 0;
export const STORE_REDIRECT = 1;
export const CUSTOM_REDIRECT = 2;

const ResetBranchKey = new ReduxAsyncAction('RESET_BRANCH_KEY');
ResetBranchKey.registerRequest(function () {
  return dash_api.post('/v1/app/branch-key').then((res) => {
    return { branch_key: res.data.branch_key };
  });
});
export const RESET_BRANCH_KEY = ResetBranchKey.constants;
export const resetBranchKey = ResetBranchKey.request;

const ResetBranchSecret = new ReduxAsyncAction('RESET_BRANCH_SECRET');
ResetBranchSecret.registerRequest(function () {
  return dash_api.post('/v1/app/branch-secret').then((res) => {
    return { branch_secret: res.data.branch_secret };
  });
});
export const RESET_BRANCH_SECRET = ResetBranchSecret.constants;
export const resetBranchSecret = ResetBranchSecret.request;
